var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"calc(100vh)","margin":"10px 0px"},attrs:{"id":"grafico-dash-comparando-evolucao-preco-compras"}})
}
var staticRenderFns = []

export { render, staticRenderFns }